export const buildTransactionQRCodeText = (data: {
  transactionId?: string;
  value?: number | string;
  pagbank?: boolean;
  partner?: { name?: string; document?: string };
  qrcode?: string;
}): string => {
  if (data.partner && data.transactionId) {
    const partnerName = data.partner.name
      ? encodeURIComponent(data.partner.name)
      : "";
    const partnerDocument = data.partner.document || "";
    const value = data.value ?? 0;
    const pagbankFlag =
      typeof data.pagbank === "boolean" ? data.pagbank : !!data.pagbank;
    return `mode=online&${data.transactionId}&${partnerDocument}&${partnerName}&${value}&${pagbankFlag}`;
  }
  return data.qrcode || "";
};
